// AgentPropertiesSection.jsx
import Properties from "../../pages/properties/Properties";
import PropertyFormModal from "../properties/PropertyFormModal";
import Accordion from "../ui/Accordion";
import { useAuthStore } from "../../store/authStore";

export default function AgentPropertiesSection({
  agentId,
  setSelectedProperty,
}) {
  const { role } = useAuthStore();
  const isAdmin = role === "admin";

  return (
    <>
      <Accordion
        title="Properties"
        className="accordion-section properties-section"
        actions={
          isAdmin && (
            <button
              type="button"
              className="btn w-auto py-1 px-3 d-flex align-center text-sm fw-semibold bg-gradient-primary btn-hover-glow rounded-20"
              onClick={(e) => {
                e.stopPropagation();
                setSelectedProperty({});
              }}
            >
              Add Property
            </button>
          )
        }
      >
        <Properties agentId={agentId} />
      </Accordion>
      <PropertyFormModal agentId={agentId} />
    </>
  );
}
